import { Colors } from "../../Colors";
import { SxProps, TextField } from "@mui/material";

export function StyledTextField({
  size = "small",
  value,
  onChange,
  sx
}: {
  size?: "small" | "medium";
  value: string | undefined;
  onChange: (value: string) => void;
  sx?: SxProps;
}) {
  return (
    <TextField
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",
          background: Colors.textfield
        },
        ...sx
      }}
      size={size}
      margin="none"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
